// Federal states / provinces per country (reference data).
// States/Provinces by country
export const STATES_BY_COUNTRY: Record<string, { value: string; label: string }[]> = {
  Germany: [
    { value: 'Baden-Württemberg', label: 'Baden-Württemberg' },
    { value: 'Bayern', label: 'Bayern' },
    { value: 'Berlin', label: 'Berlin' },
    { value: 'Brandenburg', label: 'Brandenburg' },
    { value: 'Bremen', label: 'Bremen' },
    { value: 'Hamburg', label: 'Hamburg' },
    { value: 'Hessen', label: 'Hessen' },
    { value: 'Mecklenburg-Vorpommern', label: 'Mecklenburg-Vorpommern' },
    { value: 'Niedersachsen', label: 'Niedersachsen' },
    { value: 'Nordrhein-Westfalen', label: 'Nordrhein-Westfalen' },
    { value: 'Rheinland-Pfalz', label: 'Rheinland-Pfalz' },
    { value: 'Saarland', label: 'Saarland' },
    { value: 'Sachsen', label: 'Sachsen' },
    { value: 'Sachsen-Anhalt', label: 'Sachsen-Anhalt' },
    { value: 'Schleswig-Holstein', label: 'Schleswig-Holstein' },
    { value: 'Thüringen', label: 'Thüringen' },
  ],
  Austria: [
    { value: 'Burgenland', label: 'Burgenland' },
    { value: 'Kärnten', label: 'Kärnten' },
    { value: 'Niederösterreich', label: 'Niederösterreich' },
    { value: 'Oberösterreich', label: 'Oberösterreich' },
    { value: 'Salzburg', label: 'Salzburg' },
    { value: 'Steiermark', label: 'Steiermark' },
    { value: 'Tirol', label: 'Tirol' },
    { value: 'Vorarlberg', label: 'Vorarlberg' },
    { value: 'Wien', label: 'Wien' },
  ],
  Switzerland: [
    { value: 'Aargau', label: 'Aargau' },
    { value: 'Appenzell Ausserrhoden', label: 'Appenzell Ausserrhoden' },
    { value: 'Appenzell Innerrhoden', label: 'Appenzell Innerrhoden' },
    { value: 'Basel-Landschaft', label: 'Basel-Landschaft' },
    { value: 'Basel-Stadt', label: 'Basel-Stadt' },
    { value: 'Bern', label: 'Bern' },
    { value: 'Freiburg', label: 'Freiburg' },
    { value: 'Genf', label: 'Genf' },
    { value: 'Glarus', label: 'Glarus' },
    { value: 'Graubünden', label: 'Graubünden' },
    { value: 'Jura', label: 'Jura' },
    { value: 'Luzern', label: 'Luzern' },
    { value: 'Neuenburg', label: 'Neuenburg' },
    { value: 'Nidwalden', label: 'Nidwalden' },
    { value: 'Obwalden', label: 'Obwalden' },
    { value: 'Schaffhausen', label: 'Schaffhausen' },
    { value: 'Schwyz', label: 'Schwyz' },
    { value: 'Solothurn', label: 'Solothurn' },
    { value: 'St. Gallen', label: 'St. Gallen' },
    { value: 'Tessin', label: 'Tessin' },
    { value: 'Thurgau', label: 'Thurgau' },
    { value: 'Uri', label: 'Uri' },
    { value: 'Waadt', label: 'Waadt' },
    { value: 'Wallis', label: 'Wallis' },
    { value: 'Zug', label: 'Zug' },
    { value: 'Zürich', label: 'Zürich' },
  ],
  France: [
    { value: 'Île-de-France', label: 'Île-de-France' },
    { value: 'Provence-Alpes-Côte d\'Azur', label: 'Provence-Alpes-Côte d\'Azur' },
    { value: 'Auvergne-Rhône-Alpes', label: 'Auvergne-Rhône-Alpes' },
    { value: 'Nouvelle-Aquitaine', label: 'Nouvelle-Aquitaine' },
    { value: 'Occitanie', label: 'Occitanie' },
    { value: 'Hauts-de-France', label: 'Hauts-de-France' },
    { value: 'Grand Est', label: 'Grand Est' },
    { value: 'Pays de la Loire', label: 'Pays de la Loire' },
    { value: 'Bretagne', label: 'Bretagne' },
    { value: 'Normandie', label: 'Normandie' },
    { value: 'Bourgogne-Franche-Comté', label: 'Bourgogne-Franche-Comté' },
    { value: 'Centre-Val de Loire', label: 'Centre-Val de Loire' },
    { value: 'Corse', label: 'Corse' },
  ],
  Netherlands: [
    { value: 'Drenthe', label: 'Drenthe' },
    { value: 'Flevoland', label: 'Flevoland' },
    { value: 'Friesland', label: 'Friesland' },
    { value: 'Gelderland', label: 'Gelderland' },
    { value: 'Groningen', label: 'Groningen' },
    { value: 'Limburg', label: 'Limburg' },
    { value: 'Noord-Brabant', label: 'Noord-Brabant' },
    { value: 'Noord-Holland', label: 'Noord-Holland' },
    { value: 'Overijssel', label: 'Overijssel' },
    { value: 'Utrecht', label: 'Utrecht' },
    { value: 'Zeeland', label: 'Zeeland' },
    { value: 'Zuid-Holland', label: 'Zuid-Holland' },
  ],
  Belgium: [
    { value: 'Brüssel', label: 'Brüssel' },
    { value: 'Flandern', label: 'Flandern' },
    { value: 'Wallonien', label: 'Wallonien' },
  ],
  Luxembourg: [
    { value: 'Diekirch', label: 'Diekirch' },
    { value: 'Grevenmacher', label: 'Grevenmacher' },
    { value: 'Luxemburg', label: 'Luxemburg' },
  ],
  Poland: [
    { value: 'Dolnośląskie', label: 'Niederschlesien' },
    { value: 'Kujawsko-Pomorskie', label: 'Kujawien-Pommern' },
    { value: 'Lubelskie', label: 'Lublin' },
    { value: 'Lubuskie', label: 'Lebus' },
    { value: 'Łódzkie', label: 'Łódź' },
    { value: 'Małopolskie', label: 'Kleinpolen' },
    { value: 'Mazowieckie', label: 'Masowien' },
    { value: 'Opolskie', label: 'Oppeln' },
    { value: 'Podkarpackie', label: 'Karpatenvorland' },
    { value: 'Podlaskie', label: 'Podlachien' },
    { value: 'Pomorskie', label: 'Pommern' },
    { value: 'Śląskie', label: 'Schlesien' },
    { value: 'Świętokrzyskie', label: 'Heiligkreuz' },
    { value: 'Warmińsko-Mazurskie', label: 'Ermland-Masuren' },
    { value: 'Wielkopolskie', label: 'Großpolen' },
    { value: 'Zachodniopomorskie', label: 'Westpommern' },
  ],
  'Czech Republic': [
    { value: 'Praha', label: 'Prag' },
    { value: 'Středočeský', label: 'Mittelböhmen' },
    { value: 'Jihočeský', label: 'Südböhmen' },
    { value: 'Plzeňský', label: 'Pilsen' },
    { value: 'Karlovarský', label: 'Karlsbad' },
    { value: 'Ústecký', label: 'Aussig' },
    { value: 'Liberecký', label: 'Reichenberg' },
    { value: 'Královéhradecký', label: 'Königgrätz' },
    { value: 'Pardubický', label: 'Pardubitz' },
    { value: 'Vysočina', label: 'Hochland' },
    { value: 'Jihomoravský', label: 'Südmähren' },
    { value: 'Olomoucký', label: 'Olmütz' },
    { value: 'Zlínský', label: 'Zlin' },
    { value: 'Moravskoslezský', label: 'Mährisch-Schlesien' },
  ],
  Denmark: [
    { value: 'Hovedstaden', label: 'Hauptstadt-Region' },
    { value: 'Midtjylland', label: 'Mitteljütland' },
    { value: 'Nordjylland', label: 'Nordjütland' },
    { value: 'Sjælland', label: 'Seeland' },
    { value: 'Syddanmark', label: 'Süddänemark' },
  ],
  Italy: [
    { value: 'Abruzzo', label: 'Abruzzen' },
    { value: 'Basilicata', label: 'Basilikata' },
    { value: 'Calabria', label: 'Kalabrien' },
    { value: 'Campania', label: 'Kampanien' },
    { value: 'Emilia-Romagna', label: 'Emilia-Romagna' },
    { value: 'Friuli-Venezia Giulia', label: 'Friaul-Julisch Venetien' },
    { value: 'Lazio', label: 'Latium' },
    { value: 'Liguria', label: 'Ligurien' },
    { value: 'Lombardia', label: 'Lombardei' },
    { value: 'Marche', label: 'Marken' },
    { value: 'Molise', label: 'Molise' },
    { value: 'Piemonte', label: 'Piemont' },
    { value: 'Puglia', label: 'Apulien' },
    { value: 'Sardegna', label: 'Sardinien' },
    { value: 'Sicilia', label: 'Sizilien' },
    { value: 'Toscana', label: 'Toskana' },
    { value: 'Trentino-Alto Adige', label: 'Trentino-Südtirol' },
    { value: 'Umbria', label: 'Umbrien' },
    { value: 'Valle d\'Aosta', label: 'Aostatal' },
    { value: 'Veneto', label: 'Venetien' },
  ],
  Spain: [
    { value: 'Andalucía', label: 'Andalusien' },
    { value: 'Aragón', label: 'Aragonien' },
    { value: 'Asturias', label: 'Asturien' },
    { value: 'Islas Baleares', label: 'Balearen' },
    { value: 'Canarias', label: 'Kanarische Inseln' },
    { value: 'Cantabria', label: 'Kantabrien' },
    { value: 'Castilla-La Mancha', label: 'Kastilien-La Mancha' },
    { value: 'Castilla y León', label: 'Kastilien und León' },
    { value: 'Cataluña', label: 'Katalonien' },
    { value: 'Ceuta', label: 'Ceuta' }, // autonomous city (ciudad autónoma)
    { value: 'Extremadura', label: 'Extremadura' },
    { value: 'Galicia', label: 'Galicien' },
    { value: 'La Rioja', label: 'La Rioja' },
    { value: 'Madrid', label: 'Madrid' },
    { value: 'Melilla', label: 'Melilla' }, // autonomous city (ciudad autónoma)
    { value: 'Murcia', label: 'Murcia' },
    { value: 'Navarra', label: 'Navarra' },
    { value: 'País Vasco', label: 'Baskenland' },
    { value: 'Valencia', label: 'Valencia' },
  ],
  Portugal: [
    { value: 'Norte', label: 'Nord' },
    { value: 'Centro', label: 'Zentrum' },
    { value: 'Lisboa', label: 'Lissabon' },
    { value: 'Alentejo', label: 'Alentejo' },
    { value: 'Algarve', label: 'Algarve' },
    { value: 'Açores', label: 'Azoren' },
    { value: 'Madeira', label: 'Madeira' },
  ],
  'United Kingdom': [
    { value: 'England', label: 'England' },
    { value: 'Scotland', label: 'Schottland' },
    { value: 'Wales', label: 'Wales' },
    { value: 'Northern Ireland', label: 'Nordirland' },
  ],
  Ireland: [
    { value: 'Connacht', label: 'Connacht' },
    { value: 'Leinster', label: 'Leinster' },
    { value: 'Munster', label: 'Munster' },
    { value: 'Ulster', label: 'Ulster' },
  ],
  Sweden: [
    { value: 'Stockholm', label: 'Stockholm' },
    { value: 'Västra Götaland', label: 'Västra Götaland' },
    { value: 'Skåne', label: 'Schonen' },
    { value: 'Östergötland', label: 'Östergötland' },
    { value: 'Uppsala', label: 'Uppsala' },
    { value: 'Jönköping', label: 'Jönköping' },
    { value: 'Halland', label: 'Halland' },
    { value: 'Örebro', label: 'Örebro' },
    { value: 'Södermanland', label: 'Södermanland' },
    { value: 'Dalarna', label: 'Dalarna' },
    { value: 'Gävleborg', label: 'Gävleborg' },
    { value: 'Västmanland', label: 'Västmanland' },
    { value: 'Värmland', label: 'Värmland' },
    { value: 'Norrbotten', label: 'Norrbotten' },
    { value: 'Västerbotten', label: 'Västerbotten' },
    { value: 'Västernorrland', label: 'Västernorrland' },
    { value: 'Kalmar', label: 'Kalmar' },
    { value: 'Kronoberg', label: 'Kronoberg' },
    { value: 'Blekinge', label: 'Blekinge' },
    { value: 'Jämtland', label: 'Jämtland' },
    { value: 'Gotland', label: 'Gotland' },
  ],
  Norway: [
    { value: 'Oslo', label: 'Oslo' },
    { value: 'Viken', label: 'Viken' },
    { value: 'Innlandet', label: 'Innlandet' },
    { value: 'Vestfold og Telemark', label: 'Vestfold og Telemark' },
    { value: 'Agder', label: 'Agder' },
    { value: 'Rogaland', label: 'Rogaland' },
    { value: 'Vestland', label: 'Vestland' },
    { value: 'Møre og Romsdal', label: 'Møre og Romsdal' },
    { value: 'Trøndelag', label: 'Trøndelag' },
    { value: 'Nordland', label: 'Nordland' },
    { value: 'Troms og Finnmark', label: 'Troms og Finnmark' },
  ],
  Finland: [
    { value: 'Uusimaa', label: 'Uusimaa' },
    { value: 'Varsinais-Suomi', label: 'Varsinais-Suomi' },
    { value: 'Pirkanmaa', label: 'Pirkanmaa' },
    { value: 'Pohjois-Pohjanmaa', label: 'Nordösterbotten' },
    { value: 'Keski-Suomi', label: 'Mittelfinnland' },
    { value: 'Päijät-Häme', label: 'Päijät-Häme' },
    { value: 'Satakunta', label: 'Satakunta' },
    { value: 'Pohjois-Savo', label: 'Nordsavo' },
    { value: 'Etelä-Pohjanmaa', label: 'Südösterbotten' },
    { value: 'Lappi', label: 'Lappland' },
    { value: 'Pohjanmaa', label: 'Österbotten' },
    { value: 'Kanta-Häme', label: 'Kanta-Häme' },
    { value: 'Kymenlaakso', label: 'Kymenlaakso' },
    { value: 'Etelä-Karjala', label: 'Südkarelien' },
    { value: 'Pohjois-Karjala', label: 'Nordkarelien' },
    { value: 'Etelä-Savo', label: 'Südsavo' },
    { value: 'Kainuu', label: 'Kainuu' },
    { value: 'Keski-Pohjanmaa', label: 'Mittelösterbotten' },
    { value: 'Ahvenanmaa', label: 'Åland' },
  ],
  Croatia: [
    { value: 'Zagreb', label: 'Zagreb' },
    { value: 'Split-Dalmatia', label: 'Split-Dalmatien' },
    { value: 'Istria', label: 'Istrien' },
    { value: 'Primorje-Gorski Kotar', label: 'Primorje-Gorski Kotar' },
    { value: 'Osijek-Baranja', label: 'Osijek-Baranja' },
    { value: 'Dubrovnik-Neretva', label: 'Dubrovnik-Neretva' },
    { value: 'Zadar', label: 'Zadar' },
    { value: 'Šibenik-Knin', label: 'Šibenik-Knin' },
    { value: 'Varaždin', label: 'Varaždin' },
    { value: 'Koprivnica-Križevci', label: 'Koprivnica-Križevci' },
    { value: 'Karlovac', label: 'Karlovac' },
    { value: 'Sisak-Moslavina', label: 'Sisak-Moslavina' },
    { value: 'Vukovar-Srijem', label: 'Vukovar-Srijem' },
    { value: 'Bjelovar-Bilogora', label: 'Bjelovar-Bilogora' },
    { value: 'Lika-Senj', label: 'Lika-Senj' },
    { value: 'Krapina-Zagorje', label: 'Krapina-Zagorje' },
    { value: 'Međimurje', label: 'Međimurje' },
    { value: 'Požega-Slavonia', label: 'Požega-Slawonien' },
    { value: 'Virovitica-Podravina', label: 'Virovitica-Podravina' },
    { value: 'Brod-Posavina', label: 'Brod-Posavina' },
    { value: 'Zagreb County', label: 'Gespanschaft Zagreb' },
  ],
  Hungary: [
    { value: 'Budapest', label: 'Budapest' },
    { value: 'Pest', label: 'Pest' },
    { value: 'Bács-Kiskun', label: 'Bács-Kiskun' },
    { value: 'Baranya', label: 'Baranya' },
    { value: 'Békés', label: 'Békés' },
    { value: 'Borsod-Abaúj-Zemplén', label: 'Borsod-Abaúj-Zemplén' },
    { value: 'Csongrád-Csanád', label: 'Csongrád-Csanád' },
    { value: 'Fejér', label: 'Fejér' },
    { value: 'Győr-Moson-Sopron', label: 'Győr-Moson-Sopron' },
    { value: 'Hajdú-Bihar', label: 'Hajdú-Bihar' },
    { value: 'Heves', label: 'Heves' },
    { value: 'Jász-Nagykun-Szolnok', label: 'Jász-Nagykun-Szolnok' },
    { value: 'Komárom-Esztergom', label: 'Komárom-Esztergom' },
    { value: 'Nógrád', label: 'Nógrád' },
    { value: 'Somogy', label: 'Somogy' },
    { value: 'Szabolcs-Szatmár-Bereg', label: 'Szabolcs-Szatmár-Bereg' },
    { value: 'Tolna', label: 'Tolna' },
    { value: 'Vas', label: 'Vas' },
    { value: 'Veszprém', label: 'Veszprém' },
    { value: 'Zala', label: 'Zala' },
  ],
  Romania: [
    { value: 'București', label: 'Bukarest' },
    { value: 'Cluj', label: 'Klausenburg' },
    { value: 'Timiș', label: 'Temesch' },
    { value: 'Iași', label: 'Jassy' },
    { value: 'Constanța', label: 'Konstanza' },
    { value: 'Brașov', label: 'Kronstadt' },
    { value: 'Sibiu', label: 'Hermannstadt' },
    { value: 'Alba', label: 'Alba' },
    { value: 'Argeș', label: 'Argeș' },
    { value: 'Bihor', label: 'Bihor' },
    { value: 'Dolj', label: 'Dolj' },
    { value: 'Galați', label: 'Galați' },
    { value: 'Hunedoara', label: 'Hunedoara' },
    { value: 'Maramureș', label: 'Maramuresch' },
    { value: 'Mureș', label: 'Muresch' },
    { value: 'Prahova', label: 'Prahova' },
    { value: 'Suceava', label: 'Suceava' },
  ],
  Bulgaria: [
    { value: 'Sofia City', label: 'Sofia (Stadt)' },
    { value: 'Plovdiv', label: 'Plowdiw' },
    { value: 'Varna', label: 'Warna' },
    { value: 'Burgas', label: 'Burgas' },
    { value: 'Sofia Province', label: 'Sofia (Provinz)' },
    { value: 'Stara Zagora', label: 'Stara Sagora' },
    { value: 'Blagoevgrad', label: 'Blagoewgrad' },
    { value: 'Veliko Tarnovo', label: 'Weliko Tarnowo' },
    { value: 'Pleven', label: 'Plewen' },
    { value: 'Ruse', label: 'Russe' },
    { value: 'Dobrich', label: 'Dobritsch' },
    { value: 'Pazardzhik', label: 'Pasardschik' },
  ],
  Greece: [
    { value: 'Attica', label: 'Attika' },
    { value: 'Central Macedonia', label: 'Zentralmakedonien' },
    { value: 'Thessaly', label: 'Thessalien' },
    { value: 'Western Greece', label: 'Westgriechenland' },
    { value: 'Central Greece', label: 'Mittelgriechenland' },
    { value: 'Crete', label: 'Kreta' },
    { value: 'Eastern Macedonia and Thrace', label: 'Ostmakedonien und Thrakien' },
    { value: 'Peloponnese', label: 'Peloponnes' },
    { value: 'Epirus', label: 'Epirus' },
    { value: 'Western Macedonia', label: 'Westmakedonien' },
    { value: 'Ionian Islands', label: 'Ionische Inseln' },
    { value: 'North Aegean', label: 'Nördliche Ägäis' },
    { value: 'South Aegean', label: 'Südliche Ägäis' },
  ],
  Slovakia: [
    { value: 'Bratislava', label: 'Bratislava' },
    { value: 'Trnava', label: 'Tyrnau' },
    { value: 'Trenčín', label: 'Trentschin' },
    { value: 'Nitra', label: 'Neutra' },
    { value: 'Žilina', label: 'Sillein' },
    { value: 'Banská Bystrica', label: 'Neusohl' },
    { value: 'Prešov', label: 'Preschau' },
    { value: 'Košice', label: 'Kaschau' },
  ],
  Slovenia: [
    { value: 'Central Slovenia', label: 'Zentralslowenien' },
    { value: 'Drava', label: 'Drau' },
    { value: 'Savinja', label: 'Savinja' },
    { value: 'Upper Carniola', label: 'Oberkrain' },
    { value: 'Coastal-Karst', label: 'Küste-Karst' },
    { value: 'Gorizia', label: 'Görz' },
    { value: 'Lower Sava', label: 'Untere Save' },
    { value: 'Southeast Slovenia', label: 'Südostslowenien' },
    { value: 'Mura', label: 'Mur' },
    { value: 'Carinthia', label: 'Kärnten' },
    { value: 'Inner Carniola-Karst', label: 'Innerkrain-Karst' },
    { value: 'Central Sava', label: 'Mittlere Save' },
  ],
  Turkey: [
    { value: 'Istanbul', label: 'Istanbul' },
    { value: 'Ankara', label: 'Ankara' },
    { value: 'Izmir', label: 'Izmir' },
    { value: 'Antalya', label: 'Antalya' },
    { value: 'Bursa', label: 'Bursa' },
    { value: 'Adana', label: 'Adana' },
    { value: 'Konya', label: 'Konya' },
    { value: 'Gaziantep', label: 'Gaziantep' },
    { value: 'Mersin', label: 'Mersin' },
    { value: 'Kayseri', label: 'Kayseri' },
    { value: 'Mugla', label: 'Mugla' },
    { value: 'Trabzon', label: 'Trabzon' },
    { value: 'Eskisehir', label: 'Eskisehir' },
    { value: 'Samsun', label: 'Samsun' },
    { value: 'Denizli', label: 'Denizli' },
  ],
  'United States': [
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'Kalifornien' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' },
    { value: 'District of Columbia', label: 'District of Columbia' },
  ],
  Canada: [
    { value: 'Alberta', label: 'Alberta' },
    { value: 'British Columbia', label: 'Britisch-Kolumbien' },
    { value: 'Manitoba', label: 'Manitoba' },
    { value: 'New Brunswick', label: 'New Brunswick' },
    { value: 'Newfoundland and Labrador', label: 'Neufundland und Labrador' },
    { value: 'Nova Scotia', label: 'Nova Scotia' },
    { value: 'Ontario', label: 'Ontario' },
    { value: 'Prince Edward Island', label: 'Prince Edward Island' },
    { value: 'Quebec', label: 'Québec' },
    { value: 'Saskatchewan', label: 'Saskatchewan' },
    { value: 'Northwest Territories', label: 'Nordwest-Territorien' },
    { value: 'Nunavut', label: 'Nunavut' },
    { value: 'Yukon', label: 'Yukon' },
  ],
  Australia: [
    { value: 'New South Wales', label: 'New South Wales' },
    { value: 'Victoria', label: 'Victoria' },
    { value: 'Queensland', label: 'Queensland' },
    { value: 'South Australia', label: 'South Australia' },
    { value: 'Western Australia', label: 'Western Australia' },
    { value: 'Tasmania', label: 'Tasmanien' },
    { value: 'Northern Territory', label: 'Northern Territory' },
    { value: 'Australian Capital Territory', label: 'Australian Capital Territory' },
  ],
}
